import React, { useState, useEffect } from "react";
import { Container, Grid } from "semantic-ui-react";
import { useParams } from "react-router-dom";
import { connect } from "react-redux";
import { getProducts, getAllProducts } from "../redux/actions/products";
import { getCategories } from "../redux/actions/categories";
import ProductItem from "../components/Products/ProductItem/ProductItem";

const Products = (props) => {
  const { type } = useParams();
  const [page, setPage] = useState(decodeURI(type));
  const { categories, products, getProducts, getCategories, getAllProducts } =
    props;

  useEffect(() => {
    if (decodeURI(type) === "Todos") {
      getAllProducts();
    } else {
      getProducts(decodeURI(type));
    }
    getCategories();
    setPage(decodeURI(type));
  }, [getProducts, getAllProducts, getCategories, type]);

  let quantity = 0;
  const getName = () => {
    let name = "";
    categories.map((category) => {
      if (category.id === page) {
        name = category.data.name;
        quantity = category.data.totalProducts;
      } else if (page === "Todos") {
        name = "Todos los arreglos";
      }
      return null;
    });
    return name;
  };
  return (
    <div className="container-Sections">
      <Container
        fluid
        className="locationDisplayNavbar"
        style={{ textAlign: "center" }}
      >
        <div className="w-100 mt-5 mb-2">
          <h2 className="text-center" style={{ padding: 5 }}>
            {categories && getName()}
          </h2>
          <h6>
            {decodeURI(type) !== "Todos" &&
              quantity === 0 &&
              "No hay productos en esta categoría"}
          </h6>
        </div>

        {/* <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            width: "100%",
          }}
        >
          <Message
            warning
            style={{
              width: "40%",
            }}
          >
            <Message.Header>¡Gracias por tu preferencia!</Message.Header>
            <p>Los cupos para el día de la madre están llenos.</p>
          </Message>
        </div>
 */}
        <Grid centered className="pb-5">
          <Grid.Row
            centered
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              width: "100%",
            }}
          >
            {products &&
              products.map((product) => {
                return <ProductItem key={product.id} {...product} />;
              })}
          </Grid.Row>
        </Grid>
      </Container>
    </div>
  );
};
const mapStateToProps = (state) => {
  return {
    products: state.products.products,
    categories: state.categories.categories,
    cart: state.cart,
  };
};

export default connect(mapStateToProps, {
  getProducts,
  getAllProducts,
  getCategories,
})(Products);
